<template>
  <div>
    <div class="status-box">
      <!-- 初审 -->
      <template v-if="first_review_status === 0">
        <img src="../../assets/images/unpublished.png" width="240" alt="">
        <p>作品已收到！正在初审中，请耐心等待结果。</p>
      </template>

      <!-- 初审未通过 -->
      <template v-else-if="first_review_status === 2">
        <img src="../../assets/images/team/fail.png" width="240" alt="" />
        <p>感谢团队参与！虽然这次未能晋级，但你们的演讲依然精彩，下一次挑战再见。</p>
      </template>

      <!-- 评审中 -->
      <template v-else-if="review_publish === 0 || review_status === 0 || review_status === 3 || review_status === 4">
        <img src="../../assets/images/review.png" width="240" alt="">
        <div class="result-content">
          <p>恭喜您通过初步筛选，完成线上案例赛。请点击“<a style="color: #733085;" href="https://crm.aicpa-cima-cn.com/?cmd=pageFormSubmit&opCliId=1chgftrkmkg86ws4&formId=1l262922t15ipxdlqeae8hrlnjwmf22t" target="_blank">完赛奖励</a>”申请奖项，并且在CGMA小程序中查询完赛证明（10个工作日左右发放）。目前视频进入专家评审环节，请耐心等待半决赛结果。</p>
          <img src="../../assets/images/miniprogram.png" alt="">
        </div>
      </template>

      <!-- 通过/未通过 -->
      <template v-else-if="review_status === 1 || review_status === 2">
        <img :src="cover_src" width="240" alt="" />
        <p v-if="review_status === 1">太棒了！你的作品在评审中脱颖而出，成功晋级中国大陆半决赛！</p>
        <p v-else-if="review_status === 2">感谢团队参与！虽然这次未能晋级，但你们的演讲依然精彩，下一次挑战再见。</p>
      </template>
    </div>
  </div>
</template>

<script>
import { apiGetReportTeamData } from '../../plugins/apis';

export default { 
  data() {
    return {
      review_publish: 0,
      review_status: 0,
      first_review_status: 0
    };
  }, 
  methods: {
    async getTeam(){
      let res = await apiGetReportTeamData(this.round.round_id)
      if(res.code === 200){
        this.review_status = res.data.teamData.review_status
        this.first_review_status = res.data.teamData.first_review_status
      }
      this.review_publish = this.round.review_publish
    },
  },
  mounted() {
    this.getTeam()
  },
  computed:{
    cover_src(){
        return require(`../../assets/images/team/${this.review_status === 1?'success':'fail'}.png`)
    }
  },
  props:['round']
};
</script> 

<style scoped>
.result-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.result-content img {
  width: 100px;
  margin-left: 20px;
  margin-bottom: 0;
}
</style>
